import React, { FunctionComponent } from 'react';
import sendMessageIcon from '../../../assets/icons/send_message_icon.svg';
import './chat-input-with-button.scss';
import {
  FormikProps,
} from 'formik';

interface IChatInputWithButtonProps {
  field: FormikProps<void>;
  form: FormikProps<void>;
}

const ChatInputWithButton: FunctionComponent<IChatInputWithButtonProps> = ({ field, form, ...props }): JSX.Element => (
  <div className="chat-input-with-button-form">
    <input type="text" {...props} {...field}/>
    <input type="image" alt="Send" src={sendMessageIcon} disabled={!(form?.isValid && form?.dirty)}/>
  </div>
);


export default ChatInputWithButton;
